var map = {
	"./Activity.svg": 68388,
	"./ArrowDown.svg": 99543,
	"./ArrowDropdown.svg": 11333,
	"./ArrowLeft.svg": 63481,
	"./ArrowRight2.svg": 4625,
	"./ArrowheadLeft.svg": 81401,
	"./AutoAwesomeMotion.svg": 46350,
	"./Calendar.svg": 41224,
	"./Category.svg": 9517,
	"./Chart.svg": 44409,
	"./Chat.svg": 50458,
	"./Check.svg": 56051,
	"./Chevron.svg": 76978,
	"./Close.svg": 48910,
	"./CloseBold.svg": 20033,
	"./CloseSquare.svg": 28946,
	"./Copy.svg": 26481,
	"./Create.svg": 8223,
	"./Danger.svg": 75782,
	"./Dash.svg": 70573,
	"./Delete.svg": 46531,
	"./Document.svg": 89496,
	"./Download.svg": 54430,
	"./DragAndDrop.svg": 16116,
	"./Edit.svg": 25650,
	"./Facebook.svg": 86841,
	"./Filter.svg": 15856,
	"./Filter2.svg": 78493,
	"./Headset.svg": 75760,
	"./Hide.svg": 12685,
	"./Image.svg": 77470,
	"./Image2.svg": 6051,
	"./Info.svg": 34509,
	"./InfoCircle.svg": 12406,
	"./InfoCircle2.svg": 77519,
	"./Instagram.svg": 64064,
	"./LinkedIn.svg": 53795,
	"./Loader.svg": 94388,
	"./Login.svg": 21984,
	"./Logout.svg": 81954,
	"./Message.svg": 4021,
	"./Monitor.svg": 15769,
	"./MoreVertical.svg": 60427,
	"./Play.svg": 17819,
	"./Scan.svg": 89854,
	"./Search.svg": 13586,
	"./Setting.svg": 1170,
	"./ShieldDone.svg": 22961,
	"./Show.svg": 86599,
	"./Skype.svg": 51763,
	"./Star.svg": 23974,
	"./StarCircle.svg": 89140,
	"./Sync.svg": 52612,
	"./Telegram.svg": 99526,
	"./TelegramBig.svg": 28484,
	"./ThumbDown.svg": 53692,
	"./ThumbUp.svg": 29947,
	"./TickSquare.svg": 67959,
	"./Twitter.svg": 13807,
	"./UnfoldMore.svg": 48835,
	"./User2.svg": 36772,
	"./Video.svg": 42869,
	"./Wallet.svg": 55328,
	"./Work.svg": 62709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;